/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
import { moneyFixed } from '@/tools/money.js';
import { taxCollectionPatternMap } from '@/config/staticData';
import {
  payStatusRender,
  useQuotaDialog
  // array2String
} from '@/page/settlementCenter/utils';
import { overrunQuotaOrderPeopleList } from '@/api/ajax.js';

// 没有订单号或者有标识字段，使用红色样式
const isRed = row => {
  let { isCurrentOrder, csoCustomOrderNo } = row;
  return !csoCustomOrderNo || !!+isCurrentOrder;
};

const showPeopleList = function(data) {
  useQuotaDialog.call(
    this,
    { query: { msg: data.msg } },
    overrunQuotaOrderPeopleList.bind(null, { isOrder: 1, ...data }), // isOrder  0生成订单 1支付订单 默认使用1
    require('../person.vue').default,
    '关闭'
  );
};
export default {
  index: {
    width: '60px',
    label: '序号',
    type: 'index'
  },
  fullName: {
    label: '姓名',
    prop: 'fullName'
  },
  userPhone: {
    label: '手机号',
    prop: 'userPhone'
  },
  taxCollectionPattern: {
    label: '交易结构',
    prop: 'taxCollectionPattern',
    formatter(r, c, v) {
      return taxCollectionPatternMap[v] || '-';
    }
  },
  quotaPrice: {
    label: '税筹限额',
    prop: 'quotaPrice',
    formatter(r, c, v) {
      return moneyFixed(v);
    }
  },
  csoCustomOrderNo: {
    label: '订单编号',
    headerRender(h, ctx) {
      let { fullPath } = ctx.parent.$route;
      return (
        <span>
          {fullPath === '/orderMgmt/list' ? '订单编号' : '已生成订单'}
        </span>
      );
    },
    prop: 'csoCustomOrderNo',
    formatter(r, c, v) {
      return v || '当前订单';
    }
  },
  orderNo: {
    label: '订单编号',
    prop: 'orderNo',
    formatter(r, c, v) {
      return v || '当前订单';
    }
  },
  projectName: {
    label: '项目',
    prop: 'projectName'
  },

  taskDt: {
    label: '任务月度',
    prop: 'taskDt'
  },
  projectPrice: {
    label: '自然人结算金额',
    width: '140px',
    prop: 'projectPrice',
    render(h, ctx, row) {
      return (
        <div
          style={{
            color: isRed(row) ? 'red' : '#000'
          }}
        >
          <span>{moneyFixed(row.projectPrice)}</span>
          {row.msg && (
            <el-popover
              trigger="hover"
              placement="right"
              style={{ width: '200px' }}
            >
              <div style={{ width: '200px' }}>{row.msg}</div>
              <i
                slot="reference"
                class="el-icon-warning"
                style="margin-left: 10px"
              ></i>
            </el-popover>
          )}
        </div>
      );
    }
  },
  payStatus: {
    label: '订单支付状态',
    prop: 'payStatus',
    formatter(r) {
      return payStatusRender(r);
    }
  },
  totalprojectPrice: {
    label: '累计结算金额',
    prop: 'totalprojectPrice',
    render(h, ctx, row) {
      return (
        <span type="text" style={{ color: isRed(row) ? 'red' : '#000' }}>
          {row.totalprojectPrice ? moneyFixed(row.totalprojectPrice) : '-'}
        </span>
      );
    }
  },
  handler: {
    label: '操作',
    render(h, ctx, row) {
      // query:{isOrder}  0生成订单 1支付订单
      const r = { ...(ctx.parent.defaultQuery.query || {}), ...row };
      return (
        <el-button type="text" onClick={showPeopleList.bind(ctx.parent, r)}>
          查看
        </el-button>
      );
    }
  }
};
